import {
  fetchAllTenants,
  IConfiguration,
  IOrganization as IHeaderOrganization,
  IUserData,
} from '@iamexperiences/suite-header';

import { useQuery } from 'react-query';
import { useGetCurrentOrganization } from './useGetCurrentOrganization';

export const useHeaderOrganizations = (configuration: IConfiguration, userData: IUserData) => {
  const getCurrentOrgQuery = useGetCurrentOrganization(userData.tenantId);
  const getAllTenantQuery = useQuery({
    queryKey: ['allHeaderTenants'],
    queryFn: async () => {
      return await fetchAllTenants(configuration, userData);
    },
    enabled: !!userData,
  });
  const organizations = getAllTenantQuery.data ?? [];
  const currentOrganization = getCurrentOrgQuery.data || {id: '', displayName: ''}
  return {
    data: !getAllTenantQuery.data || !getCurrentOrgQuery.data ? []
    : organizations.some((org: IHeaderOrganization) => org.tenantId === currentOrganization.id)
      ? organizations
      : [
          ...organizations,
          {
            displayName: currentOrganization.displayName,
            tenantId: currentOrganization.id,
            isCurrent: currentOrganization.id === userData.tenantId,
            isHome: currentOrganization.id === userData.homeTenantId,
          },
        ],
    isLoading: getCurrentOrgQuery.isLoading || getAllTenantQuery.isLoading,
    isError: getCurrentOrgQuery.isError || getAllTenantQuery.isError
  };
};
